import { modalAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys)

export const modalTheme = defineMultiStyleConfig({
  baseStyle: props => ({
    overlay: {
      bg: "blackAlpha.500",
    },
    dialog: {
      borderRadius: "md",
      bg: props.colorMode === "light" ? "white" : "gray.800",
    },
    body: {
      my: "10px",
      mx: "8px",
    },
  }),
})
